import { HEARTBEAT_INTERVAL_MS, TRANSLATION_KEY as WATCHLIST_TRANSLATION_KEY } from '../watchlist/constants';

export const TRANSLATION_KEY = `${WATCHLIST_TRANSLATION_KEY}.ALERTS`;

export const WATCHLIST_FEATURE = 'watchlist';
export const AI_LAB_SECTION = 'ai_lab';
export const SINGULAR_AI_FLAG = 'singular_ai';

export const WATCHLIST_PATH = '/react/watchlist';

export const STORAGE_KEY = 'singular-monitor-alerts';
export const IDLE_INTERVAL_MS = HEARTBEAT_INTERVAL_MS * 10;

export const SNOOZE_MS = 60 * 60 * 1000;

export const SUMMARY_CLAMP_CHARS = 190;

export const GROUPED_TOAST_MAX_ROWS = 3;

export const ALERT_METRICS_LIMIT = 3;
